import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  Calendar,
  ArrowRight,
  Sparkles,
  Briefcase,
  Network,
  Award,
  Wallet,
  Users,
  ShieldCheck,
  GraduationCap,
} from "lucide-react";
import WhatsAppIcon from "@/components/icons/WhatsAppIcon";

const CALENDAR_URL = "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1Uy8H-tbIBGE0qbOrbAWnHA4KzFPCjRz4IejemGD-zNYnoUALlZoFgshQPOHkR9vqxr7H_iGR_";
const WHATSAPP_BASE = "https://wa.me/393773660476";

const programs = [
  {
    id: "rimborso-100",
    icon: Wallet,
    title: "Rimborso 100% ai tuoi clienti",
    text:
      "Strategia digitale che permette ai tuoi clienti di ricevere fino al 100% di ciò che spendono nella tua attività, senza fare sconti e aumentando la fidelizzazione.",
    image:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=800&q=70",
  },
  {
    id: "entrata-extra",
    icon: Sparkles,
    title: "Entrata extra mensile",
    text:
      "Una soluzione sostenibile e compatibile con la tua attività attuale per generare un flusso di reddito aggiuntivo grazie alla tecnologia.",
    image:
      "https://images.unsplash.com/photo-1579621970795-87facc2f976d?auto=format&fit=crop&w=800&q=70",
  },
  {
    id: "strategica-aziende",
    icon: Briefcase,
    title: "Consulenza strategica aziendale",
    text:
      "Per aziende che vogliono essere accompagnate nella trasformazione digitale: analisi di mercato, posizionamento, processi e crescita organizzata.",
    image:
      "https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=800&q=70",
  },
  {
    id: "professionista-digitale",
    icon: GraduationCap,
    title: "Professionista nel digitale",
    text:
      "Percorso con possibili accrediti CFP, CFU ed ECM per ottenere certificazioni e qualificazioni riconosciute nel mondo digitale.",
    image:
      "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=800&q=70",
  },
  {
    id: "registro-consulente",
    icon: ShieldCheck,
    title: "Iscrizione al registro A.C.D.T.",
    text:
      "Iscrizione al Registro come Consulente e Consumatore Digitale, Tecnologico e di Sostenibilità — Legge 4/2013, aggregato MIMIT.",
    image:
      "https://images.unsplash.com/photo-1606326608606-aa0b62935f2b?auto=format&fit=crop&w=800&q=70",
  },
  {
    id: "formazione-leadership",
    icon: Award,
    title: "Formazione & leadership",
    text:
      "Percorso formativo con il Metodo di Mare e libro incluso. Per chi vuole crescere come leader, costruire reti e dare struttura al proprio team.",
    image:
      "https://images.unsplash.com/photo-1552581234-26160f608093?auto=format&fit=crop&w=800&q=70",
  },
  {
    id: "rete-commerciale",
    icon: Network,
    title: "Sviluppo rete commerciale",
    text:
      "Affiancamento dedicato a professionisti e networker per costruire reti strutturate, autonome e sostenibili nel tempo.",
    image:
      "https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=800&q=70",
  },
  {
    id: "digital-marketing",
    icon: Sparkles,
    title: "Digital Marketing",
    text:
      "Creazione di video impattanti, strategia pubblicitaria web e social, piano editoriale di immagini e reel. Per aumento di fatturato, visibilità e più clienti, in modo misurabile.",
    image:
      "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=800&q=70",
  },
  {
    id: "funnel-landing-prodotti",
    icon: Briefcase,
    title: "Funnel, landing page e prodotti digitali",
    text:
      "Specialista in landing page ad alta conversione e nella creazione di funnel creator per lo sviluppo e il lancio del tuo prodotto digitale, dall'idea alla vendita.",
    image:
      "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?auto=format&fit=crop&w=800&q=70",
  },
];

const studi = [
  {
    name: "Multiservizi Digital Tech Solutions",
    address: "Via Pietro Nenni, 16 — Modica (RG)",
  },
  {
    name: "A.C.D.T.",
    address: "Via Giordano Cavestro, 1 — 97019 Vittoria (RG)",
  },
];

export default function Consulenza() {
  const [selected, setSelected] = useState(null);

  const waUrlFor = (program) =>
    `${WHATSAPP_BASE}?text=${encodeURIComponent(
      `Ciao Michele, vorrei informazioni sulla consulenza: "${program.title}".`
    )}`;

  return (
    <section
      id="consulenza"
      data-testid="consulenza-section"
      className="relative py-24 md:py-32 border-t border-[#E5E1DA] bg-gradient-to-b from-[#F9F8F6] via-[#FFF4E8] to-[#F9F8F6]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        {/* Header */}
        <div className="grid md:grid-cols-12 gap-10 mb-16 md:mb-20 items-end">
          <div className="md:col-span-7">
            <p className="overline">Consulenza personalizzata</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-[1.05]">
              Chiedi la tua
              <br />
              <em className="text-[#E89B6C]">consulenza.</em>
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="text-lg font-light leading-relaxed text-[#3A4F6B]">
              Sviluppa la tua mente, scegli il tuo percorso, diventa un
              professionista. Affianco aziende e privati con il{" "}
              <em>Metodo di Mare</em> per migliorare presenza online,
              fidelizzazione clienti e crescita organizzata.
            </p>
          </div>
        </div>

        {/* Value proposition strip */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#E5E1DA] border border-[#E5E1DA] mb-16">
          {[
            { n: "01", t: "Digitale & Sostenibilità", s: "Percorsi strutturati e attuali" },
            { n: "02", t: "Entrata Extra", s: "Soluzioni compatibili e sostenibili" },
            { n: "03", t: "Professionista Digitale", s: "Metodo, competenze, riconoscimento" },
            { n: "04", t: "Tutela Online", s: "Sicurezza e conformità" },
          ].map((item) => (
            <div key={item.n} className="bg-[#F9F8F6] p-6">
              <p className="font-serif-display text-3xl text-[#E89B6C]">{item.n}</p>
              <p className="font-serif-display text-lg mt-3 text-[#0B192C] leading-tight">
                {item.t}
              </p>
              <p className="text-xs text-[#3A4F6B] mt-2 font-light">{item.s}</p>
            </div>
          ))}
        </div>

        {/* Program selector — featured header */}
        <div className="relative mt-20 mb-10">
          {/* Decorative orbs */}
          <div
            aria-hidden
            className="absolute -top-6 left-1/2 -translate-x-1/2 w-[80%] h-32 opacity-30 blur-3xl pointer-events-none"
            style={{
              background:
                "radial-gradient(ellipse, #E89B6C 0%, transparent 70%)",
            }}
          />
          <div className="relative flex flex-col md:flex-row md:items-end md:justify-between gap-6 pb-8 border-b-2 border-[#0B192C]">
            <div className="max-w-2xl">
              <div className="inline-flex items-center gap-2 px-3 py-1 border border-[#E89B6C] bg-[#FFF4E8] mb-4">
                <span className="w-2 h-2 bg-[#E89B6C] animate-pulse rounded-full" />
                <span className="overline text-[#0B192C]">
                  {programs.length} servizi disponibili
                </span>
              </div>
              <h3 className="font-serif-display text-3xl md:text-4xl lg:text-5xl leading-[1.05] text-[#0B192C]">
                Scegli il programma
                <br />
                <em className="text-[#E89B6C]">
                  di interesse
                </em>{" "}
                <span className="inline-block animate-pulse text-[#E89B6C]">↓</span>
              </h3>
              <p className="mt-4 text-base font-light text-[#3A4F6B] max-w-xl">
                Clicca sul servizio che ti interessa: ti preparerò un messaggio
                pronto per WhatsApp o una call dedicata.
              </p>
            </div>
            <div className="hidden md:flex items-baseline gap-3 text-[#0B192C]">
              <span className="font-serif-display text-7xl lg:text-8xl leading-none text-[#E89B6C]">
                {String(programs.length).padStart(2, "0")}
              </span>
              <span className="overline text-[#3A4F6B] pb-2">
                programmi
                <br />
                attivi
              </span>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {programs.map((p, i) => {
            const Icon = p.icon;
            const isActive = selected?.id === p.id;
            return (
              <motion.button
                key={p.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
                onClick={() => setSelected(isActive ? null : p)}
                data-testid={`consulenza-program-${p.id}`}
                className={`text-left border transition-all duration-300 group overflow-hidden flex flex-col ${
                  isActive
                    ? "bg-[#0B192C] border-[#0B192C] text-[#F9F8F6] shadow-[0_20px_40px_-15px_rgba(11,25,44,0.3)]"
                    : "bg-[#FFFFFF] border-[#E5E1DA] text-[#0B192C] hover:border-[#0B192C] hover:shadow-[0_15px_30px_-15px_rgba(11,25,44,0.2)]"
                }`}
              >
                {/* Image */}
                <div className="relative aspect-[16/10] overflow-hidden bg-[#F4E8D6]">
                  <img
                    src={p.image}
                    alt={p.title}
                    loading="lazy"
                    className={`w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 ${
                      isActive ? "" : "grayscale-[20%] group-hover:grayscale-0"
                    }`}
                  />
                  {/* Top gradient for legibility of the icon */}
                  <div
                    aria-hidden
                    className={`absolute inset-0 transition-opacity ${
                      isActive
                        ? "bg-gradient-to-t from-[#0B192C]/60 via-[#0B192C]/20 to-transparent"
                        : "bg-gradient-to-t from-[#0B192C]/30 via-transparent to-transparent"
                    }`}
                  />
                  {/* Floating icon badge */}
                  <div
                    className={`absolute top-4 left-4 w-11 h-11 flex items-center justify-center transition-colors ${
                      isActive
                        ? "bg-[#E89B6C] text-[#0B192C]"
                        : "bg-[#F9F8F6]/95 backdrop-blur-sm text-[#E89B6C] group-hover:bg-[#E89B6C] group-hover:text-[#F9F8F6]"
                    }`}
                  >
                    <Icon size={18} strokeWidth={1.4} />
                  </div>
                  {isActive && (
                    <span className="absolute top-4 right-4 overline text-[#E89B6C] bg-[#0B192C]/80 px-2 py-1">
                      Selezionato
                    </span>
                  )}
                </div>

                {/* Content */}
                <div className="p-6 md:p-7 flex-1 flex flex-col">
                  <h3 className="font-serif-display text-xl md:text-2xl leading-tight">
                    {p.title}
                  </h3>
                  <p
                    className={`mt-3 text-sm font-light leading-relaxed flex-1 ${
                      isActive ? "text-[#F9F8F6]/85" : "text-[#3A4F6B]"
                    }`}
                  >
                    {p.text}
                  </p>
                  <div
                    className={`mt-5 inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] ${
                      isActive ? "text-[#E89B6C]" : "text-[#0B192C]/60"
                    }`}
                  >
                    {isActive ? "Selezionato" : "Seleziona"}
                    <ArrowRight
                      size={12}
                      className={`transition-transform ${
                        isActive ? "rotate-90" : "group-hover:translate-x-1"
                      }`}
                    />
                  </div>
                </div>
              </motion.button>
            );
          })}
        </div>

        {/* Action panel */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-12 border border-[#0B192C] bg-[#0B192C] text-[#F9F8F6] p-8 md:p-12"
          data-testid="consulenza-action-panel"
        >
          <div className="grid md:grid-cols-12 gap-8 items-center">
            <div className="md:col-span-6">
              <p className="overline text-[#E89B6C]">
                {selected ? "Prossimo passo" : "Prenotazione diretta"}
              </p>
              <h3 className="font-serif-display text-3xl md:text-4xl mt-3 leading-tight">
                {selected
                  ? selected.title
                  : "Prenota una call gratuita di orientamento."}
              </h3>
              <p className="mt-4 text-base font-light text-[#F9F8F6]/80 max-w-lg">
                {selected
                  ? "Scegli come continuare: prenota direttamente in agenda oppure scrivimi su WhatsApp per parlarne."
                  : "30 minuti per capire dove sei, dove vuoi andare e quale percorso può aiutarti davvero."}
              </p>
            </div>
            <div className="md:col-span-6 flex flex-col sm:flex-row md:justify-end gap-3">
              <a
                href={CALENDAR_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="consulenza-calendar-btn"
                className="group inline-flex items-center justify-center gap-3 px-7 py-4 bg-[#E89B6C] text-[#0B192C] text-sm uppercase tracking-[0.2em] hover:bg-[#F9F8F6] transition-colors"
              >
                <Calendar size={16} />
                Prenota la call
                <ArrowRight
                  size={14}
                  className="transition-transform group-hover:translate-x-1"
                />
              </a>
              <a
                href={
                  selected
                    ? waUrlFor(selected)
                    : `${WHATSAPP_BASE}?text=${encodeURIComponent(
                        "Ciao Michele, vorrei prenotare una consulenza."
                      )}`
                }
                target="_blank"
                rel="noopener noreferrer"
                data-testid="consulenza-whatsapp-btn"
                className="inline-flex items-center justify-center gap-3 px-7 py-4 border border-[#F9F8F6]/30 text-[#F9F8F6] text-sm uppercase tracking-[0.2em] hover:bg-[#F9F8F6]/10 transition-colors"
              >
                <WhatsAppIcon size={16} className="text-[#25D366]" />
                Scrivi su WhatsApp
              </a>
            </div>
          </div>
        </motion.div>

        {/* Studi addresses */}
        <div className="mt-16 grid md:grid-cols-2 gap-6">
          {studi.map((s) => (
            <div
              key={s.name}
              className="border border-[#E5E1DA] bg-[#FFFFFF] p-6 md:p-8 flex items-start gap-5"
            >
              <Users
                size={22}
                strokeWidth={1.3}
                className="text-[#E89B6C] mt-1 flex-shrink-0"
              />
              <div>
                <p className="overline">Studio</p>
                <p className="font-serif-display text-xl mt-2 text-[#0B192C]">
                  {s.name}
                </p>
                <p className="text-sm font-light text-[#3A4F6B] mt-1">
                  {s.address}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
